export default "__VITE_ASSET__a9f8945b__"